/**
 * Cart Drawer Helper Functions
 * Extra utilities for the cart drawer
 */
(function() {
  // Wait for DOM content to be loaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    check();
  }
  
  function check() {
    var badges = document.querySelectorAll('.dbtfy-trust_badge');
    badges.forEach(badge => {
      if (!badge.hasAttribute('badge-setting-done')) {
        badge.setAttribute('badge-setting-done', '1');
        var styles = window.getComputedStyle(badge);
        if (styles.display === 'none' && badge.parentElement.classList.contains('drawer__inner-section')) {
          badge.parentElement.style.display = 'none';
        }
      }
    });
    setTimeout(check, 10);
  }
})();
